export default __webpack_public_path__ + "static/02-e06c5a624c42742843279616008b7867.gif";